<template>
  <div class="dealsheet">
    <Loader
      v-if="loaderEnabled"
      :logo="loaderLogo"
    ></Loader>
    <KTCodePreview v-bind:title="title">
      <template v-slot:toolbar>
        <template>
          <div>
            <b-modal
              hide-footer
              id="modal-scrollable modal-lg"
              size="lg"
              class="text-center"
              ref="modal-scrollable"
              scrollable
              title="Danh sách dealsheet sắp hết hạn"
            >
              <p class="my-4">
                <b-table
                  bordered
                  hover
                  :items="listItemExpire"
                  :fields="fieldExpire"
                  :per-page="10"
                  :current-page="currentPageExpire"
                  :busy="isLoading"
                >
                  <template v-slot:table-busy>
                    <vcl-table
                      :speed="5"
                      :animate="true"
                      :columns="10"
                    />
                  </template>
                  <template #cell(code)="row">
                    <span
                      class="font-weight-bold cursor-pointer"
                      @click="editItem(row.item)"
                    >
                      {{ row.item.code }}
                    </span>
                      <CompanyCodeBadge
                        :companyCode="row.item.companyCode"
                        :companyName="row.item.companyName"
                      />
                  </template>
                  <template #cell(index)="row">
                    {{ row.item.index }}
                  </template>
                  <template #cell(targetMin)="row"> {{ row.item.targetMin }}% </template>
                  <template #cell(achievedRatio)="row">
                    <span class="text-danger">{{ row.item.achievedRatio || 0 }}%</span>
                  </template>
                  <template #cell(priority)="row">
                    {{ checkPriority(row.item.priority) }}
                  </template>
                </b-table>
                <b-row>
                  <b-col fixed>
                    <p
                      class="mt-3 text-dark"
                      style="font-weight: 500"
                    >
                      Tổng số: {{ totalItemsExpire }}
                    </p>
                  </b-col>
                  <b-pagination
                    class="custom-pagination"
                    v-show="listItemExpire.length > 10"
                    v-model="currentPageExpire"
                    :total-rows="listItemExpire.length"
                    :per-page="10"
                    align="right"
                  >
                  </b-pagination>
                </b-row>
              </p>
              <b-button
                style="width: 80px"
                variant="secondary"
                size="sm"
                @click="hideModal()"
              >
                <strong>Đóng</strong>
              </b-button>
            </b-modal>
          </div>
        </template>
        <div class="row">
          <div>
            <b-dropdown
              size="sm"
              id="dropdown-1"
              right
              v-if="checkPermissions(['DEALSHEET_INSERT', 'DEALSHEET_EXPORT'])"
            >
              <template slot="button-content">
                <i
                  style="font-size: 1rem"
                  class="fas fa-cog"
                ></i>
                <span class="font-weight-bolder">Thao tác</span>
              </template>
              <b-dropdown-item
                v-if="checkPermission('DEALSHEET_INSERT')"
                @click="importExcel"
              >
                <span>
                  <i
                    style="font-size: 1rem"
                    class="flaticon2-download-2"
                  ></i>
                  &nbsp; Nhập Excel</span
                >
              </b-dropdown-item>
              <b-dropdown-item
                v-if="checkPermission('DEALSHEET_EXPORT')"
                @click="downloadExcel"
              >
                <span>
                  <i
                    style="font-size: 1rem"
                    class="flaticon-file-2"
                  ></i>
                  &nbsp; Xuất Excel</span
                >
              </b-dropdown-item>
            </b-dropdown>
          </div>
          <div class="ml-3">
            <router-link
              to="/deal-sheets/info-deal-sheet"
              v-if="checkPermission('DEALSHEET_INSERT')"
            >
              <button
                type="button"
                class="btn btn-primary font-weight-bolder btn-sm"
              >
                <i
                  style="font-size: 1rem"
                  class="flaticon2-add-1"
                ></i
                >Thêm mới
              </button>
            </router-link>
          </div>
        </div>
      </template>
      <template v-slot:preview>
        <!-- Header session -->
        <b-row class="mb-3">
          <b-col cols="2">
            <b-input-group>
              <date-picker
                placeholder="Ngày bắt đầu"
                class="form-control form-control-sm"
                :config="dpConfigs.date"
                v-model="apiParams.startDate"
              ></date-picker>
            </b-input-group>
          </b-col>
          <b-col cols="2">
            <b-input-group>
              <date-picker
                placeholder="Ngày kết thúc"
                class="form-control form-control-sm"
                :config="dpConfigs.date"
                v-model="apiParams.endDate"
              ></date-picker>
            </b-input-group>
          </b-col>
          <b-col cols="4">
            <b-input
              size="sm"
              placeholder="Tìm kiếm..."
              v-model="apiParams.searchText"
            ></b-input>
          </b-col>
          <b-col cols="2">
            <b-form-select
              class="select-style"
              size="sm"
              v-model="apiParams.orderByPriority"
              :options="[
                { orderBy: 'ASC', name: 'Độ ưu tiên: Cao đến Thấp' },
                { orderBy: 'DESC', name: 'Độ ưu tiên: Thấp đến Cao' },
              ]"
              text-field="name"
              value-field="orderBy"
            >
              <template #first>
                <b-form-select-option :value="null">--Độ ưu tiên--</b-form-select-option>
              </template>
            </b-form-select>
          </b-col>
          <b-col cols="2">
            <b-form-select
              class="select-style"
              size="sm"
              v-model="apiParams.isActive"
              :options="listStatus"
              value-field="id"
              text-field="name"
            >
              <template v-slot:first>
                <b-form-select-option :value="null">--Trạng thái--</b-form-select-option>
              </template>
            </b-form-select>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="2">
            <b-form-select
              class="select-style"
              size="sm"
              v-model="apiParams.targetType"
              :options="targetTypeOptions"
              value-field="id"
              text-field="name"
            >
              <template v-slot:first>
                <b-form-select-option :value="null">--Loại chỉ tiêu--</b-form-select-option>
              </template>
            </b-form-select>
          </b-col>
          <b-col cols="2">
            <b-form-select
              class="select-style"
              size="sm"
              v-model="apiParams.companyId"
              :options="listCompany"
              value-field="id"
              text-field="name"
            >
              <template #first>
                <b-form-select-option :value="null">--Doanh nghiệp--</b-form-select-option>
              </template>
            </b-form-select>
          </b-col>
          <b-col cols="2">
            <b-form-select
              class="select-style"
              size="sm"
              v-model="selectedPageSize"
              :options="optionPageSize"
            >
              <template #first>
                <b-form-select-option :value="null">--Hiển thị--</b-form-select-option>
              </template>
            </b-form-select>
          </b-col>
        </b-row>
        <b-row class="mb-5 mt-5">
          <b-col md="1">
            <b-button
              class="font-weight-bold"
              variant="primary"
              style="width: 70px"
              size="sm"
              @click.enter="onFilter"
              :disabled="isLoading"
              >Lọc</b-button
            >
          </b-col>
          <b-col
            cols="auto"
            class="mr-2"
          >
            <b-button
              style="font-weight: 600; width: auto; min-width: 120px"
              variant="secondary"
              size="sm"
              @click="deleteFilter"
              v-if="activeFilterCount > 0"
              :disabled="isLoading || activeFilterCount === 0"
            >
              Xóa bộ lọc
              <span v-if="activeFilterCount > 0">({{ activeFilterCount }})</span>
            </b-button>
          </b-col>
          <b-col
            cols="auto"
            v-show="selectedItems.length"
            v-if="checkPermission('DEALSHEET_DELETE')"
          >
            <b-button
              class="font-weight-bol"
              variant="danger"
              style="width: 70px"
              size="sm"
              @click="
                showDeleteAlert(
                  `${modalTitle} cấu hình đã chọn`,
                  `Bạn có chắc muốn xoá ${selectedItems.length} cấu hình đã chọn`,
                  selectedItems,
                  confirmDeleteDealSheet,
                )
              "
              >Xoá ({{ selectedItems.length }})
            </b-button>
          </b-col>
        </b-row>
        <!-- End of Header session -->
        <b-table
          :items="computedListItem"
          :fields="fields"
          bordered
          hover
          :busy="isLoading"
          class="table-hover"
        >
          <template v-slot:table-busy>
            <vcl-table
              :speed="5"
              :animate="true"
              :columns="10"
            />
          </template>
          <template #head(checkbox)>
            <b-form-checkbox
              v-model="selectAll"
              @change="toggleSelecedAll"
              class="b-custom-control-lg"
            >
            </b-form-checkbox>
          </template>
          <template #cell(progress)="row">
            <div>
              <span class="d-block text-right small mb-1">
                {{
                  row.item.progress != null && row.item.progress !== ''
                    ? `${row.item.progress}%`
                    : '-'
                }}
              </span>
              <b-progress
                :value="row.item.progress"
                :max="100"
                variant="primary"
                class="mb-2"
              >
                <b-progress-bar
                  :value="row.item.progress"
                  variant="primary"
                  :striped="true"
                  :animated="true"
                ></b-progress-bar>
              </b-progress>
            </div>
          </template>
          <template #cell(checkbox)="row">
            <b-form-checkbox
              v-model="row.item.checked"
              @change="handleItemChange(row.item)"
              class="b-custom-control-lg"
            >
            </b-form-checkbox>
          </template>
          <template #cell(code)="row">
            <div class="d-flex flex-column">
              <span
                class="font-weight-bold text-primary cursor-pointer hover-link"
                @click="openDetailModal(row.item)"
                v-b-tooltip.hover.right
                title="Xem chi tiết dealsheet"
              >
                {{ row.item.code }}
              </span>
              <template v-if="row.item.purchaseOrders && row.item.purchaseOrders.length">
                <small
                  v-for="po in row.item.purchaseOrders"
                  :key="po.id"
                  class="text-success mt-1 cursor-pointer hover-link d-block"
                  v-b-tooltip.hover.right
                  title="Xem phiếu đặt hàng nhập"
                  @click.stop="linkToPurchaseOrder(po)"
                >
                  <i
                    class="fas fa-file-invoice mr-1 text-success"
                    style="font-size: 0.75rem"
                  ></i>
                  {{ po.code }}
                </small>
              </template>
              <CompanyCodeBadge
                :company-code="row.item.companyCode"
                :company-name="row.item.companyName"
                class="mt-1 align-self-start"
              />
            </div>
          </template>
          <template #cell(isActiveName)="row">
            <span :class="row.item.isActive ? 'badge badge-success' : 'badge badge-warning'">
              {{ row.item.isActiveName }}
            </span>
          </template>
          <template #cell(targetType)="row">
            <span>
              {{ DEAL_SHEET_TARGET_TYPE_NAME[row.item.targetType] }}
            </span>
          </template>
          <template #cell(actions)="row">
            <div class="d-flex justify-content-center">
              <b-dropdown
                size="sm"
                id="dropdown-left"
                no-caret
                right
              >
                <template slot="button-content">
                  <i class="flaticon2-settings"></i>
                </template>
                <b-dropdown-item
                  v-if="checkPermission('DEALSHEET_UPDATE')"
                  @click="editItem(row.item)"
                >
                  <span style="color: #3f4254; font-size: 12px">
                    <i
                      style="font-size: 1rem"
                      class="flaticon2-pen"
                    ></i>
                    &nbsp; Chỉnh sửa
                  </span>
                </b-dropdown-item>
                <b-dropdown-item
                  v-if="
                    checkPermission('PO_INSERT') &&
                    row.item.targetType === DEAL_SHEET_TARGET_TYPE.SALE_IN
                  "
                  @click="
                    redirectToCreatePurchaseOrder({
                      dealSheetIds: row.item.id,
                      isCreate: true,
                    })
                  "
                >
                  <span style="color: #3f4254; font-size: 12px">
                    <i
                      style="font-size: 1rem"
                      class="flaticon2-file-1"
                    ></i>
                    &nbsp; Tạo phiếu đặt hàng nhập
                  </span>
                </b-dropdown-item>
                <b-dropdown-item
                  v-if="checkPermission('DEALSHEET_DELETE')"
                  @click="
                    showDeleteAlert(
                      modalTitle,
                      `${modalDesc} ${row.item.code}`,
                      row.item,
                      confirmDeleteDealSheet,
                    )
                  "
                >
                  <span style="color: #3f4254; font-size: 12px">
                    <i
                      style="font-size: 1rem; color: #d33"
                      class="flaticon2-rubbish-bin-delete-button"
                    ></i>
                    &nbsp; Xóa
                  </span>
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </template>
        </b-table>
        <b-row>
          <b-col>
            <p
              class="mt-3 text-dark"
              style="font-weight: 500"
            >
              Hiển thị {{ fromNo }} - {{ toNo }} / {{ totalItems }} bản ghi
            </p>
          </b-col>
          <b-col>
            <BPaginationNavCustom
              :number-of-pages="numberOfPage"
              :current-page="currentPage"
              :total-page="numberOfPage"
              @page-change="fetchData"
            />
          </b-col>
        </b-row>
        <!-- End of Paginate session -->
      </template>
    </KTCodePreview>
    <DealSheetImportExcel
      :dealshetIdDel="dealshetDeleted"
      @onRefresh="fetchData"
      @deleteAlert="deleteDealsheet"
    />
    <DealSheetExportExcel :apiParams="apiParams" />
    <b-modal
      id="modal-dealsheet-info"
      ref="modalDealSheetInfo"
      size="xl"
      scrollable
      hide-footer
      title="Chi tiết dealsheet"
      @hidden="modalDealSheetId = null"
    >
      <Info
        v-if="modalDealSheetId"
        :deal-sheet-id="modalDealSheetId"
        embedded
        @close="closeDealSheetModal"
        @saved="onModalSaved"
      />
    </b-modal>
  </div>
</template>

<script>
import KTCodePreview from '@/view/content/CodePreview.vue'
import { SET_BREADCRUMB } from '@/core/services/store//modules/breadcrumbs.module'
import { showDeleteAlert } from '@/utils/sweet-alert2'
import { mapGetters } from 'vuex'
import Loader from '@/view/content/Loader.vue'
import timeUtils from '@/utils/date'
import debounce from 'debounce'
import { TIME_TRIGGER } from '@/utils/constants'
import DealSheetExportExcel from '@/view/components/dealsheet/DealSheetExportExcel'
import DealSheetImportExcel from '@/view/components/dealsheet/DealSheetImportExcel'
import { DEAL_SHEET_PRIORITY_NAME, DEAL_SHEET_TARGET_TYPE_NAME } from '@/utils/enum-name'
import { DEAL_SHEET_PRIORITY, DEAL_SHEET_TARGET_TYPE } from '@/utils/enum'
import { ACTIVE_STATUS_OPTIONS, TARGET_TYPE_OPTIONS } from './utils/constants'
import { DEALSHEET_LIST_FIELDS, DEALSHEET_LIST_EXPIRE_FIELDS } from './utils/tableConfig'
import { VclTable } from 'vue-content-loading'
import BPaginationNavCustom from '@/view/base/bootstrap/BPaginationNavCustom.vue'
import { getDealSheets, getDealSheetsExpire, deleteDealSheet } from './utils/dealSheetApi'
import { mapDealSheetListItem, mapExpiredDealSheetItem } from './utils/listHelpers'
import permissionMixin from '@/view/mixins/permission.mixin'
import commonMixin from '@/view/mixins/api-common.mixins'
import CompanyCodeBadge from '@/view/components/common/CompanyCodeBadge.vue'
import Info from './Info.vue'
import { formatDBDate } from '@/utils/date'

export default {
  mixins: [permissionMixin, commonMixin],
  data() {
    return {
      modalDesc: 'Bạn có chắc xoá dealsheet mã',
      modalTitle: 'Xoá ',
      modalDealSheetId: null,
      hasLoadedExpiredDealSheets: false,
      dealshetDeleted: '',
      selectedItems: [],
      listItemExpire: [],
      listItemSoft: [],
      selectAll: false,
      title: '',
      apiParams: {
        searchText: null,
        startDate: null,
        endDate: null,
        isActive: null,
        type: null,
        orderByPriority: null,
        targetType: null,
        companyId: null,
      },
      listCompany: [],
      listItem: [],
      numberOfPage: 1,
      totalItems: 0,
      totalItemsExpire: 0,
      currentPageExpire: 1,
      selectedPageSize: null,
      limit: 10,
      optionPageSize: [10, 25, 50, 100],
      fieldExpire: DEALSHEET_LIST_EXPIRE_FIELDS,
      fields: DEALSHEET_LIST_FIELDS,
      dpConfigs: timeUtils.DP_CONFIG,
      listStatus: ACTIVE_STATUS_OPTIONS,
      targetTypeOptions: TARGET_TYPE_OPTIONS,
      isLoading: false,
      DEAL_SHEET_TARGET_TYPE_NAME,
      DEAL_SHEET_TARGET_TYPE,
    }
  },
  components: {
    KTCodePreview,
    Loader,
    DealSheetImportExcel,
    DealSheetExportExcel,
    VclTable,
    BPaginationNavCustom,
    CompanyCodeBadge,
    Info,
  },
  mounted() {
    this.title = 'Danh sách Dealsheet'
    this.$store.dispatch(SET_BREADCRUMB, [{ title: this.title }])
  },
  watch: {
    selectedPageSize: function (newOption) {
      this.limit = newOption
      this.fetchData()
    },
  },
  created() {
    this.fetchData()
    this.fetchCompanies().then((data) => {
      this.listCompany = data
    })
    this.hasLoadedExpiredDealSheets = sessionStorage.getItem('hasLoadedExpiredDealSheets') || false
    if (!this.hasLoadedExpiredDealSheets) {
      this.getAllDealSheetExpire()
      sessionStorage.setItem('hasLoadedExpiredDealSheets', true)
    }
  },
  methods: {
    linkToPurchaseOrder(item) {
      const route = this.$router.resolve({
        name: 'info-purchase-orders',
        query: { id: item.id },
      })
      window.open(route.href, '_blank')
    },
    redirectToCreatePurchaseOrder(query) {
      const route = this.$router.resolve({
        name: 'info-purchase-orders',
        query,
      })
      window.open(route.href, '_blank')
    },
    showDeleteAlert,
    showModal() {
      this.$refs['modal-scrollable'].show()
    },
    hideModal() {
      this.$refs['modal-scrollable'].hide()
    },
    checkPriority(priority) {
      if (!priority) return priority
      const priorityNum = Number(priority)
      if (priorityNum === DEAL_SHEET_PRIORITY.HIGH) {
        return DEAL_SHEET_PRIORITY_NAME[DEAL_SHEET_PRIORITY.HIGH]
      }
      if (priorityNum === DEAL_SHEET_PRIORITY.MEDIUM) {
        return DEAL_SHEET_PRIORITY_NAME[DEAL_SHEET_PRIORITY.MEDIUM]
      }
      if (priorityNum === DEAL_SHEET_PRIORITY.LOW) {
        return DEAL_SHEET_PRIORITY_NAME[DEAL_SHEET_PRIORITY.LOW]
      }
      return priority
    },
    toggleSelecedAll() {
      for (let i = 0; i < this.computedListItem.length; i++) {
        this.listItem[i].checked = this.selectAll
        this.updateSelectedItems()
      }
    },
    handleItemChange(item) {
      if (!item.checked) {
        this.selectAll = false
      }
      this.updateSelectedItems()
    },
    updateSelectedItems() {
      this.selectedItems = this.computedListItem
        .filter((item) => item.checked)
        .map((item) => item.id)
      if (this.selectedItems.length === this.computedListItem.length) {
        this.selectAll = true
      }
    },
    downloadExcel() {
      this.$bvModal.show('modal-dealsheet-excel')
    },
    deleteDealsheet(data) {
      const { code } = data
      showDeleteAlert(
        `${this.modalTitle} cấu hình trong hệ thống`,
        `${this.modalDesc} ${code}`,
        data,
        this.confirmDeleteDealSheet,
      )
    },
    importExcel() {
      this.$bvModal.show('modal-deal-sheet-import')
    },
    deleteFilter: function () {
      this.apiParams = {}
      this.apiParams.startDate = null
      this.apiParams.endDate = null
      this.apiParams.isActive = null
      this.selectedPageSize = null
      this.apiParams.orderByPriority = null
      this.apiParams.targetType = null
      this.apiParams.searchText = ''
      this.apiParams.companyId = null
      this.fetchData()
    },
    editItem: function (item) {
      this.$router.push({
        name: 'info-deal-sheet',
        query: { id: item.id },
      })
    },
    openDetailModal(item) {
      if (!item?.id) return
      this.modalDealSheetId = item.id
      this.$nextTick(() => this.$refs.modalDealSheetInfo.show())
    },
    closeDealSheetModal() {
      this.$refs.modalDealSheetInfo?.hide()
    },
    onModalSaved() {
      this.$refs.modalDealSheetInfo?.hide()
      this.fetchData()
    },
    filterDebounce: debounce(function () {
      this.$route.query.page = 1
      this.$router.push({
        name: 'deal-sheets',
      })
      this.fetchData()
    }, TIME_TRIGGER),
    onFilter() {
      this.$route.query.page = 1
      this.$router.push({
        name: 'deal-sheets',
      })
      this.fetchData()
    },
    getParamFilters() {
      return {
        page: this.$route.query.page || 1,
        limit: this.limit,
        searchText: this.apiParams.searchText ? this.apiParams.searchText.trim() : null,
        startDate: formatDBDate(this.apiParams.startDate),
        endDate: formatDBDate(this.apiParams.endDate),
        isActive: this.apiParams.isActive,
        orderByPriority: this.apiParams.orderByPriority,
        targetType: this.apiParams.targetType,
        companyId: this.apiParams.companyId || undefined,
      }
    },
    async getAllDealSheetExpire() {
      this.listItemExpire = await getDealSheetsExpire()
      this.listItemExpire = this.listItemExpire.map(mapExpiredDealSheetItem)
      if (this.listItemExpire.length) {
        this.showModal()
      }
    },
    async fetchData() {
      if (this.isLoading) return

      this.isLoading = true
      this.selectedItems = []
      this.selectAll = false
      this.page = this.$route.query.page || 1

      try {
        const params = this.getParamFilters()
        const dataset = await getDealSheets(params)

        this.totalItems = dataset.totalRow
        this.numberOfPage = dataset.totalPage || 1
        this.listItem = dataset.dataset.map((item, index) =>
          mapDealSheetListItem(item, index, this.page, this.limit),
        )
      } finally {
        this.isLoading = false
      }
    },
    async deleteItem(id) {
      const success = await deleteDealSheet(id)
      if (success) {
        this.dealshetDeleted = Array.isArray(id) ? id[0] : id
        this.selectedItems = []
        this.fetchData()
      }
    },
    confirmDeleteDealSheet(item) {
      if (Array.isArray(item)) {
        this.deleteItem(item)
        return
      }
      this.deleteItem(item.id)
    },
  },
  computed: {
    ...mapGetters(['breadcrumbs', 'pageTitle', 'layoutConfig']),
    loaderEnabled() {
      return !/false/.test(this.layoutConfig('loader.type'))
    },
    loaderLogo() {
      return process.env.BASE_URL + this.layoutConfig('loader.logo')
    },
    computedListItem() {
      return this.listItem
    },
    activeFilterCount() {
      const p = this.apiParams
      let count = 0
      if (p.startDate) count++
      if (p.endDate) count++
      if (p.searchText && String(p.searchText).trim()) count++
      if (p.isActive != null && p.isActive !== '') count++
      if (p.orderByPriority != null && p.orderByPriority !== '') count++
      if (p.targetType != null && p.targetType !== '') count++
      if (p.companyId != null && p.companyId !== '') count++
      return count
    },
    currentPage() {
      return Number(this.$route.query.page) || 1
    },
    fromNo() {
      return (this.page - 1) * this.limit + 1
    },
    toNo() {
      return this.page * this.limit
    },
  },
}
</script>

<style lang="scss" scoped>
.dealsheet {
  .icon:hover {
    background-color: #90c6fc;
  }

  .bootstrap-datetimepicker-widget.dropdown-menu {
    width: 21em;
  }
}
</style>

<style scoped>
.hover-link:hover {
  opacity: 0.6;
  text-decoration: underline;
}
.table th,
.table td {
  padding: 0.75rem;
  vertical-align: middle;
  border-top: 1px solid #ecf0f3;
}

.table.b-table.table-sm > thead > tr > [aria-sort]:not(.b-table-sort-icon-left),
.table.b-table.table-sm > tfoot > tr > [aria-sort]:not(.b-table-sort-icon-left) {
  background-position: right calc(1.5rem / 2) center;
  padding-right: calc(0.3rem + 0.65em);
}
</style>
